
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.375 19.198h-11v1.25h11v-1.25zM13.854 9.135H10a.625.625 0 100 1.25h3.854a.625.625 0 100-1.25zM16.77 12.052H10a.625.625 0 100 1.25h6.77a.625.625 0 100-1.25z"}}),_c('path',{attrs:{"d":"M20.132 3.628a.626.626 0 00-.671.102l-1.75 1.548-1.753-1.567a.625.625 0 00-.833 0l-1.75 1.565-1.75-1.565a.624.624 0 00-.833 0L9.039 5.278 7.29 3.73a.626.626 0 00-1.039.468v11.125H4.125a.625.625 0 00-.625.625v1.52a2.983 2.983 0 002.98 2.98v-1.25c-.954 0-1.73-.776-1.73-1.73v-.895h9.792v.896a2.983 2.983 0 002.979 2.979 2.983 2.983 0 002.979-2.98V4.199a.625.625 0 00-.368-.57zm-.882 13.84c0 .954-.776 1.73-1.73 1.73-.953 0-1.728-.776-1.728-1.73v-1.52a.625.625 0 00-.625-.625H7.5V5.585l1.128.998c.237.21.594.209.83-.002l1.75-1.565 1.75 1.564a.625.625 0 00.834 0l1.75-1.565 1.75 1.565a.625.625 0 00.83.003l1.128-.998V17.47z"}})])
          )
        }
      }
    